import { defaultAllTasksFilterDocument } from '@griply/utils';
import { useUser } from 'shared/hooks/use-user';

export const useAllTasksFilterDocument = () => {
  const user = useUser();
  return user?.settings?.filters?.allTasks ?? defaultAllTasksFilterDocument;
};
